import styled from 'styled-components';
import tw from 'twin.macro';

export const StyledFooter = styled.footer`
    ${tw`fixed bottom-0 flex items-center justify-between flex-1 w-full p-2 bg-paper`}
`;

export const StyledFooterImage = styled.figure`
    ${tw`flex justify-start w-64`}

    & > img {
        ${tw`h-20`}
    }
`;

export const StyledImageLeft = styled(StyledFooterImage)`
    ${tw`justify-start`}
`;

export const StyledImageRight = styled(StyledFooterImage)`
    ${tw`justify-end pr-2`}
`;